export default id => (dispatch) => {
  dispatch({ type: "APP/HTML", payload: { id } });
};
